export default "__VITE_ASSET__BosDWa04__"